// Castle Design System — aligned with castle-vision
export const theme = {
  colors: {
    // Primary accent (bright blue-cyan)
    primary: {
      50:  '#eef6fc',
      100: '#d4eaf6',
      200: '#a5d4ef',
      300: '#6fb5e0',  // main accent
      400: '#6fb5e0',
      500: '#4fa2d4',
      600: '#3d8fbe',
      700: '#2e7aaa',
      800: '#1c5f8f',
      900: '#0e3d66',
    },

    accent: {
      blue:   '#6fb5e0',
      cyan:   '#6fb5e0',
      purple: '#9B59B6',
      pink:   '#EC7063',
    },

    // Neutral — dark navy scale
    neutral: {
      0:   '#ffffff',
      50:  '#eef0f8',
      100: '#d8ddf0',
      200: '#b8c0e0',
      300: '#909bbf',
      400: '#6a789f',
      500: '#4f5b82',
      600: '#3a4468',
      700: '#2c3350',
      800: '#1c1f2d',
      900: '#14161f',
      950: '#0e1020',
    },

    // Semantic
    success: '#10B981',
    warning: '#F59E0B',
    error:   '#c44040',
    info:    '#6fb5e0',

    // Surfaces
    bg: {
      primary:   '#14161f',
      secondary: '#1c1f2d',
      card:      '#1c1f2d',
      hover:     '#252a3d',
      input:     '#1a1d2e',
    },

    text: {
      primary:   '#eff0f8',
      secondary: '#9ea7c4',
      muted:     '#6a789f',
      inverse:   '#14161f',
    },

    border: {
      default: '#2c3350',
      hover:   '#3a4468',
      focus:   '#6fb5e0',
    },
  },

  typography: {
    fontFamily: {
      sans: "'Montserrat', ui-sans-serif, system-ui, sans-serif",
      mono: "'Space Grotesk', ui-monospace, monospace",
    },
    fontSize: {
      xs:   '0.75rem',
      sm:   '0.875rem',
      base: '1rem',
      lg:   '1.125rem',
      xl:   '1.25rem',
      '2xl':'1.5rem',
      '3xl':'1.875rem',
      '4xl':'2.25rem',
      '5xl':'3rem',
    },
    fontWeight: {
      normal:   400,
      medium:   500,
      semibold: 600,
      bold:     700,
    },
    lineHeight: {
      tight:   1.25,
      normal:  1.5,
      relaxed: 1.75,
    },
  },

  spacing: {
    0:  '0',
    1:  '0.25rem',
    2:  '0.5rem',
    3:  '0.75rem',
    4:  '1rem',
    5:  '1.25rem',
    6:  '1.5rem',
    8:  '2rem',
    10: '2.5rem',
    12: '3rem',
    16: '4rem',
    20: '5rem',
  },

  borderRadius: {
    none: '0',
    sm:   '0.125rem',
    base: '0.125rem',
    md:   '0.25rem',
    lg:   '0.375rem',
    xl:   '0.5rem',
    '2xl':'0.75rem',
    full: '9999px',
  },

  shadows: {
    sm:   '0 1px 2px 0 rgba(0,0,0,0.3)',
    base: '0 4px 6px -1px rgba(0,0,0,0.4)',
    md:   '0 10px 15px -3px rgba(0,0,0,0.5)',
    lg:   '0 20px 25px -5px rgba(0,0,0,0.5)',
    xl:   '0 25px 50px -12px rgba(0,0,0,0.6)',
    glow: '0 0 20px rgba(111,181,224,0.35)',
  },

  transitions: {
    fast:   '150ms ease-in-out',
    base:   '200ms ease-in-out',
    slow:   '300ms ease-in-out',
    slower: '500ms ease-in-out',
  },

  breakpoints: {
    sm:   '640px',
    md:   '768px',
    lg:   '1024px',
    xl:   '1280px',
    '2xl':'1536px',
  },

  zIndex: {
    dropdown:     1000,
    sticky:       1020,
    fixed:        1030,
    modalBackdrop:1040,
    modal:        1050,
    popover:      1060,
    tooltip:      1070,
  },
};

export const getCSSVariables = () => {
  const vars = {};
  Object.entries(theme.colors).forEach(([key, value]) => {
    if (typeof value === 'object') {
      Object.entries(value).forEach(([shade, color]) => {
        vars[`--color-${key}-${shade}`] = color;
      });
    } else {
      vars[`--color-${key}`] = value;
    }
  });
  Object.entries(theme.spacing).forEach(([key, value]) => {
    vars[`--spacing-${key}`] = value;
  });
  Object.entries(theme.borderRadius).forEach(([key, value]) => {
    vars[`--radius-${key}`] = value;
  });
  return vars;
};

export default theme;
